import api from './api';

export const downloadService = {
  getAllDownloads: () => api.get('/downloads'),
  getActiveDownloads: () => api.get('/downloads/active'),
  getDownloadById: (id) => api.get(`/downloads/${id}`),
  createDownload: (data) => {
    if (data instanceof FormData) {
      return api.post('/downloads', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return api.post('/downloads', data);
  },
  updateDownload: (id, data) => {
    if (data instanceof FormData) {
      return api.put(`/downloads/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }
    return api.put(`/downloads/${id}`, data);
  },
  deleteDownload: (id) => api.delete(`/downloads/${id}`),
  reorderDownload: (id, order) => api.put(`/downloads/${id}/order`, { order_position: order }),
};
